import React, { Component } from "react";
import { VhModal } from "msd";
import { LOGIN_URL } from "common/constants";

/**
 * 中转页面，
 * 现在处理场景--账号被修改了后强制退出提示信息
 *
 * @class MsTransit
 * @extends {Component}
 */
class MsTransit extends Component {
  public componentDidMount() {
    VhModal.error({
      content: "登录已失效，请重新登录",
      onOk: () => {
        window.location.href = LOGIN_URL;
      }
    });
  }
  public render() {
    return (
      <div />
    );
  }
}
export default MsTransit;
